import React from 'react';
import config from '@medflex/utils/config';
import isPatientUserId from '@medflex/utils/isPatientUserId';
import { CLIENT_TYPES } from '@medflex/utils/constants';
import PhysicianContextMenu from './PhysicianContextMenu';
import { ComposerContextMenuPropTypes } from './propTypes';
import StandaloneChatContextMenu from './StandaloneChatContextMenu';

const ComposerContextMenu = ({
  registerFileInput,
  actionItems,
  t,
  isWideScreen,
  isDisabled,
  id,
  insertSnippet,
  isPamSession,
}) => {
  // for standalone chat we have specific context menu
  if (config.CLIENT_TYPE === CLIENT_TYPES.CHAT) {
    return (
      <StandaloneChatContextMenu
        registerFileInput={registerFileInput}
        actionItems={actionItems}
        t={t}
        isWideScreen={isWideScreen}
        isDisabled={isDisabled}
      />
    );
  }

  if (isPatientUserId(id)) {
    return null;
  }

  return (
    <PhysicianContextMenu
      registerFileInput={registerFileInput}
      actionItems={actionItems}
      t={t}
      isWideScreen={isWideScreen}
      isDisabled={isDisabled}
      insertSnippet={insertSnippet}
      isPamSession={isPamSession}
    />
  );
};

ComposerContextMenu.propTypes = ComposerContextMenuPropTypes;

export default ComposerContextMenu;
